module.exports = () => Math.floor(Date.now() / 1000);
